import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormlyFieldConfig, FormlyFormOptions } from '@ngx-formly/core';
import { StepData, Template } from 'src/app/models/Step';
import { WorkflowLanguageService } from '@services/workflow-language.service';

@Component({
    selector: 'app-step-preview',
    templateUrl: './step-preview.component.html',
    styleUrls: ['./step-preview.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StepPreviewComponent implements OnInit,OnChanges {
  @Input('stepData') stepData?: StepData
  @Input('stepListCount') stepListCount?
  @Input('workflowName') workflowName?
  @Input() type?
  @Input() workflowTranslations?
  @Output() workflowTranslationsChange: EventEmitter<string> = new EventEmitter<any>();


  @Input() selectedLayoutNo?: number
  @Input() template?: Template
  @Input() selectedStepOrder?: number
  @Input() totalSectionCount?: number
  @Input() sectionStepsCount?: number
  @Input() sectionStepOrder?: number
  @Input() viewOnly?: boolean

  @Output() selectedLayoutNoChange: EventEmitter<number> = new EventEmitter<number>()
  @Output() emptyLayout: EventEmitter<boolean> = new EventEmitter<boolean>()
  @Output() templateChange: EventEmitter<any> = new EventEmitter<any>()

  @Output() templateChangeAvailable: EventEmitter<any> = new EventEmitter<any>()
  @Output() onPreviewEvent: EventEmitter<any> = new EventEmitter<any>()
  @Output() onPreviewRowDelete: EventEmitter<any> = new EventEmitter<any>()
  @Output() onPreviewColumnDelete: EventEmitter<any> = new EventEmitter<any>()

  @ViewChild('vertical') vElement: ElementRef;
  @ViewChild('horizontal') hElement: ElementRef;
  @ViewChild('div1') div1: ElementRef;
  @ViewChild('div2') div2: ElementRef;
  @ViewChild('step') step: ElementRef;


  width: number = 10;

  layoutCount = 1
  parentFlexDirection = "column"
  firstFlexGrow = 1
  secondFlexGrow = 1
  templateName = ''

  form = new UntypedFormGroup({})
  model: any = {}
  processedLayouts: any[] = []

  selectedLang: string

  options: FormlyFormOptions = {
    formState: {
      disabled: true
    }
  };

  isMouseDown

  width1 = 47;
  width2 = 50;
  public startX = 0;
  public startWidth1 = 0;

  direction = 'horizontal';

  height1 = 47;
  height2 = 50;
  public startY = 0;
  public startHeight1 = 0;

  constructor(private workflowLanguageService: WorkflowLanguageService) { 
    this.selectedLang = this.workflowLanguageService.currentLang.code
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Layout process işlemi
    if (changes?.['stepData'] || changes?.['workflowTranslations']) {
      this.processLayouts()
    }
    
    if (changes?.['template']?.currentValue && Object.keys(changes?.['template']?.currentValue).length>0) {
      this.layoutCount = changes['template']?.currentValue.count
      this.firstFlexGrow = changes['template']?.currentValue.weights[0]
      this.secondFlexGrow = changes['template']?.currentValue.weights[1]
      this.parentFlexDirection = changes['template']?.currentValue.orientation
      this.templateName = changes['template']?.currentValue.name
      
      if(changes['template']?.currentValue.orientation == 'row' && changes['template']?.currentValue.weights.length>1) {
        this.patchRatio('vertical')
        this.direction = 'vertical'
        this.height1 = 100
        this.height2 = 100
      }
      if(changes['template']?.currentValue.orientation == 'column' && changes['template']?.currentValue.weights.length>1) {
        this.patchRatio('horizontal')
        this.direction = 'horizontal'
        this.width1 = 100
        this.width2 = 100
      }
      if(changes['template']?.currentValue.count == 1) {
        this.width1 = 100
        this.width2 = null
        this.height1 =100
        this.height2 =100

      }
    }
  }

  ngOnInit(): void {
    this.processLayouts()
    
    if(this.template && Object.keys(this.template).length>0){
      this.layoutCount = this.template.weights.length
      this.firstFlexGrow = this.template.weights[0]
      this.secondFlexGrow = this.template.weights[1]
      this.parentFlexDirection = this.template.orientation
      this.templateName = this.template.name
    }
    if(this.parentFlexDirection == 'row' && this.template.weights.length>1) {
      this.direction = 'vertical'
      this.height1 = 100
      this.height2 = 100
    }
    if(this.parentFlexDirection == 'column') {
      this.direction = 'horizontal'
      this.width1 = 100
      this.width2 = 100
    }
  }

  onLayoutSelect(no: number): void {
    if (this.selectedLayoutNo != no) {
      this.selectedLayoutNo = no
      this.selectedLayoutNoChange.emit(no) 
    }
  }

  deleteLayout() {
    this.emptyLayout.emit(true)
  }

  patchRatio(direction) {
    if(this.firstFlexGrow == 1) {
      direction == 'vertical' ? this.width1 = 50 : this.height1 = 50
    }
    if(this.secondFlexGrow == 1) {
      direction == 'vertical' ? this.width2 = 50 : this.height2 = 50
    }
    if(this.firstFlexGrow <=10 && this.secondFlexGrow <=10 && (this.firstFlexGrow !==1)) {
      direction == 'vertical' ? this.width1 = this.firstFlexGrow*10 : this.height1 = this.firstFlexGrow*10
      direction == 'vertical' ? this.width2 =this.secondFlexGrow*10 : this.height2 =this.secondFlexGrow*10
    }
  }

  findDecimal(value) {
    if(value) {
      const stringValue = (value).toString();
      const decimalIndex = stringValue.indexOf('.');
      return  parseInt(stringValue.charAt(decimalIndex + 1))
    }else{
      return null
    }
    
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(event: any) {
    if(this.templateName !== 'fullscreen') {
      if (this.parentFlexDirection == 'row') {
        let weight1 =  this.findDecimal(this.width1) <=5 ? Math.floor(this.width1)/10 : Math.ceil(this.width1)/10
        let weight2 =  this.findDecimal(this.width2) <=5 ? Math.floor(this.width2)/10 : Math.ceil(this.width2)/10

        weight1 = this.findDecimal(weight1) <=5 ? Math.floor(weight1) : Math.ceil(weight1)
        weight2 = this.findDecimal(weight2) <=5 ? Math.floor(weight2) : Math.ceil(weight2)

        if((weight1 + weight2) < 10) {
          weight1 = weight1 + 1
        }

        let templateObj = {
          count : this.template.count,
          name : this.template.name,
          orientation : this.template.orientation,
          weights : [weight1,weight2]
        }
        this.templateChange.emit(templateObj)
    } else {

      let weight1 =  this.findDecimal(this.height1) <=5 ? Math.floor(this.height1)/10 : Math.ceil(this.height1)/10
      let weight2 =  this.findDecimal(this.height2) <=5 ? Math.floor(this.height2)/10 : Math.ceil(this.height2)/10

      weight1 = this.findDecimal(weight1) <=5 ? Math.floor(weight1) : Math.ceil(weight1)
      weight2 = this.findDecimal(weight2) <=5 ? Math.floor(weight2) : Math.ceil(weight2)

      if((weight1 + weight2) < 10) {
        weight1 = weight1 + 1
      }

      let templateObj = {
        count : this.template.count,
        name : this.template.name,
        orientation : this.template.orientation,
        weights : [weight1,weight2]
      }
      this.templateChange.emit(templateObj)
    }
    
    this.startX = 0;
    this.startY = 0;
    }
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: any) {
    if (this.startX) {
      this.templateChangeAvailable.emit(true)
      const delta = event.clientX - this.startX;
      let newWidth1 = this.startWidth1 + delta / this.step.nativeElement.clientWidth * 100;
      if (newWidth1 < 30 || newWidth1 > 70) {
        return;
      }
      this.width1 = newWidth1;
      this.width2 = 100 - newWidth1;
    }
    if (this.startY) {
      this.templateChangeAvailable.emit(true)
      const delta = event.clientY - this.startY;
      let newHeight1 = this.startHeight1 + delta / this.step.nativeElement.clientHeight * 100;
      if (newHeight1 < 30 || newHeight1 > 70) {
        return;
      }
      this.height1 = newHeight1;
      this.height2 = 100 - newHeight1;
    }
  }

  onMouseDown(event: any) {
    if (this.parentFlexDirection == 'row') {
      this.startX = event.clientX;
      this.startWidth1 = this.width1;
    } else {
      this.startY = event.clientY;
      this.startHeight1 = this.height1;
    }
  }

  emitPreviewUpdates(data) {
    this.onPreviewEvent.emit(data)
  }

  onRowDeleted(rowIndexData) {
    this.onPreviewRowDelete.emit(rowIndexData)
  }

  onColumnDeleted(columnIndexData) {
    this.onPreviewColumnDelete.emit(columnIndexData)
  }

  processLayouts() {
    if (!this.stepData?.layouts || !this.workflowTranslations) return

    this.processedLayouts = this.stepData.layouts.map(layout => ({
      ...layout,
      items: layout.items?.map(item => this.processLayoutItem(item)) || []
    }))
  }

  processLayoutItem(item: any) {
    if (!item) return item

    const processedItem = { ...item }

    // HTML widget için translation'ı resolve et
    if (item.type === 'html' && item.templateOptions?.html) {
      const translationId = item.templateOptions.html
      let htmlContent = this.workflowTranslations[this.selectedLang]?.[translationId]
      
      // Eğer translation'dan gelen content yoksa, translation ID'nin kendisi HTML content olabilir
      if (!htmlContent && typeof translationId === 'string' && translationId.includes('<!DOCTYPE html>')) {
        htmlContent = translationId
      }
      
      if (htmlContent) {
        // Tam HTML dokümantından sadece content kısmını çıkar
        let cleanContent = htmlContent
        if (htmlContent.includes('<!DOCTYPE html>')) {
          const bodyMatch = htmlContent.match(/<body><div>(.*?)<\/div><\/body>/s)
          cleanContent = bodyMatch ? bodyMatch[1] : htmlContent
        }
        
        // Quill Editor formatlarını koru ve liste formatlarını düzelt
        if (cleanContent) {
          // Sadece ql-ui span'lerini temizle, diğer span'leri (font size vs.) koru
          cleanContent = cleanContent.replace(/<span class="ql-ui" contenteditable="false"><\/span>/g, '')
          
          // Liste formatlarını düzelt ama diğer formatları (font size, color etc.) koru
          cleanContent = cleanContent.replace(/<ol>([\s\S]*?)<\/ol>/g, (match, innerContent) => {
            const listItems = innerContent.match(/<li[^>]*>[\s\S]*?<\/li>/g) || []
            
            let hasBullet = false
            let hasOrdered = false
            
            listItems.forEach(item => {
              if (item.includes('data-list="bullet"')) {
                hasBullet = true
              } else if (item.includes('data-list="ordered"') || (!item.includes('data-list='))) {
                hasOrdered = true
              }
            })
            
            if (hasBullet && !hasOrdered) {
              return match.replace('<ol>', '<ul>').replace('</ol>', '</ul>')
            } else {
              return match
            }
          })
          
          // Sadece data-list attributelerini temizle, font size class'larını KORUMAYA DEVAM ET
          cleanContent = cleanContent.replace(/ data-list="(bullet|ordered)"/g, '')
          
          // Font size, color, background formatları zaten Quill tarafından korunuyor
          // Bu formatları silmiyoruz
        }
        
        // Template options'ı güncelle
        processedItem.templateOptions = {
          ...item.templateOptions,
          html: cleanContent
        }
      }
    }

    return processedItem
  }
}